export default {"src":"/_next/static/media/logo-white.292db954.svg","height":369,"width":1515};